import React, { Component } from "react";
import _ from "lodash";

import { Translate } from "react-redux-i18n";

import Rating from "../../utils/components/Rating";

import {
  momentModule,
  parseAddress,
  calculateDistance,
  calculateTime,
  roundToDecimals,
  getPlug,
  getPlugStatus,
  calculateEstimatedCost,
} from "../../utils/Utils";

import "../../../styles/components/map/chargerInfo/ChargerTitle.scss";
import favorite from "../../../styles/images/favorite.svg";
import favorite_selected from "../../../styles/images/favorite_selected.svg";
import charger from "../../../styles/images/station_circle.svg";

const { moment } = momentModule;

class ChargerTitle extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      maxPower: null,
      minTariff: null,
    };
  }

  componentDidMount() {
    this._mounted = true;
    this.getPlugStats();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  async getPlugStats() {
    if (!this.props.hasOwnProperty("compareBtn")) {
      const maxPower = this.getHighestPower();
      const minTariff = await this.getLowestTariff();
      this.safeSetState({ maxPower, minTariff });
    }
  }

  getLowestTariff() {
    let costArr = []

    this.props.charger.properties.plugs.forEach(plug => {
      if(plug.amperage && plug.voltage && plug.power){
        if(!Number.isNaN(plug.amperage) && !Number.isNaN(plug.voltage) && !Number.isNaN(plug.power)){
          costArr.push(calculateEstimatedCost(30, this.props.charger.properties, plug))
        }
      }
    });

    if(costArr.length > 0)
      return Promise.all(costArr).then(res => _.maxBy(res, "totalCost") && _.maxBy(res, "totalCost").totalCost);
    else
      return null
  }

  getHighestPower() {
    const maxPower = this.props.charger.properties.plugs.reduce((prev, curr) =>
      prev.power > curr.power ? prev : curr
    );
    return maxPower && maxPower.power !== -1 && maxPower.power !== 0 ? maxPower.power : -1;
  }

  renderDistanceTime() {
    if (this.props.currentLocation) {
      const distance = calculateDistance(
        Array.from(this.props.currentLocation).reverse(),
        this.props.charger.properties.geometry.coordinates,
        "kilometers"
      );
      const time = calculateTime(distance);

      return (
        roundToDecimals(distance, 1) +
        "km - " +
        moment.duration(time, "minutes").format("h[h] m[m]")
      );
    }
    return null;
  }

  renderPlugLabels() {
    const { maxPower, minTariff } = this.state;
    if (maxPower !== null && minTariff !== null) {
      return (
        <div className="labels-plugs-container">
          <div className="labels">
            <div className="label">
              <Translate value="chargerTitle_price" />
              <b>{minTariff !== -1 ? `${roundToDecimals(minTariff, 2)}€ / 30min` : "-"}</b>
            </div>
            <div className="label">
              <Translate value="chargerTitle_power" />
              <b>{maxPower !== -1 ? `up to ${maxPower}kW` : "-"}</b>
            </div>
          </div>
          <div className="plugs">
            {this.props.charger.properties.plugs.map(plug => (
              <div key={plug.plugId} className="plug">
                <img src={getPlug(plug.connectorType).borderless} alt="connector" />
                <div
                  className={
                    "status " + (plug.hasOwnProperty("status") && getPlugStatus(plug.status))
                  }
                />
              </div>
            ))}
          </div>
        </div>
      );
    }
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="chargerTitle">
        <div className="rating-fav-container">
          {
            !this.props.hasOwnProperty("compareBtn") ? (
              <div className="rating">
                {this.props.charger.properties.hasOwnProperty("rating") && (
                  <Rating value={Math.round(this.props.charger.properties.rating)} />
                )}
              </div>) : (
                <div/>
              )
          }
          {
            !this.props.hasOwnProperty("compareBtn") ? (
              <button
                type="button"
                className="clear"
                onClick={() =>
                  this.props.isFavorite
                    ? this.props.toggleFavorite("delete")
                    : this.props.toggleFavorite("put")
                }
              >
                <img
                  src={this.props.isFavorite ? favorite_selected : favorite}
                  className="favorite"
                  alt="favorite"
                />
              </button>
            ) : (
              <div/>
            )
          }
        </div>
        <div className="pic-title-container">
          <img
            src={
              Array.isArray(this.props.charger.properties.imageContent)
                ? this.props.charger.properties.imageContent[0] || charger
                : this.props.charger.properties.imageContent || charger
            }
            alt=""
          />
          <div className="title">
            <b>{this.props.charger.properties.name}</b>
            <p>{parseAddress(this.props.charger.properties.address)}</p>
            {this.props.hasOwnProperty("extended") && (
              <div className="distance">{this.renderDistanceTime()}</div>
            )}
          </div>
        </div>
        {this.props.hasOwnProperty("extended") && this.renderPlugLabels()}
        {this.props.hasOwnProperty("compareBtn") && (
          <button type="button" onClick={e => this.props.compareBtn(this.props.charger.properties)}>
            <Translate value="chargerTitle_addToComparator" />
          </button>
        )}
      </div>
    );
  }
}

export default ChargerTitle;
